export { StoryInfoTrait } from './storyInfoTrait';
